import React from "react";
import "../../../styles/w_2484/w-2484Style.css";
import F2848Page1 from "./F2848Page1";
import F2848Page2 from "./F2848Page2";

interface F2848FormProps {
  value?: any;
  onChange?: (patch: any) => void;
  loading?: boolean;
}

/**
 * Hosts the two Form 2848 sheets.
 *
 * Each #pdf-content-page-* section is exactly one US Letter sheet, so a
 * capture maps onto a PDF page 1:1 with no slicing.
 */
const F2848Form = ({ value, onChange, loading }: F2848FormProps) => (
  <div id="pdf-content" className="f2848-screen">
    <div id="pdf-content-page-1" className="f2848-page">
      <F2848Page1 value={value} onChange={onChange} disabled={loading} />
    </div>
    <div id="pdf-content-page-2" className="f2848-page">
      <F2848Page2 value={value} onChange={onChange} disabled={loading} />
    </div>
  </div>
);

export default F2848Form;
